var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 40,
    viewBox: "0 0 61 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 19.9415C61 20.4735 60.7901 20.9837 60.4165 21.3598C60.0429 21.7359 59.5363 21.9473 59.0079 21.9473H6.80916L21.3513 36.5639C21.7254 36.9442 21.9352 37.4578 21.9352 37.993C21.9352 38.5282 21.7254 39.0418 21.3513 39.4221C20.9705 39.7928 20.4616 40 19.9319 40C19.4023 40 18.8934 39.7928 18.5126 39.4221L0.583927 21.3706C0.209852 20.9903 0 20.4768 0 19.9415C0 19.4063 0.209852 18.8927 0.583927 18.5125L18.5126 0.461004C18.8996 0.141166 19.391 -0.022284 19.8911 0.00244667C20.3912 0.0271773 20.8643 0.23832 21.2184 0.594806C21.5725 0.951292 21.7822 1.42763 21.8067 1.93117C21.8313 2.43471 21.669 2.92945 21.3513 3.31915L6.80916 17.9358H59.0079C59.5363 17.9358 60.0429 18.1471 60.4165 18.5233C60.7901 18.8994 61 19.4096 61 19.9415Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.d8cdcf1fdf180b6d88d013c658de9bbf.svg";
export { ForwardRef as ReactComponent };